export default __webpack_public_path__ + "static/media/style1.bdace2bf.svg";